import React from 'react';
import messages from "res/messages/farsi";
import Space from "components/space/Space";
import {Divider} from "@material-ui/core";

import ICDownloadDesktop from 'res/images/download_desktop.png';
import ICCafeBazzar from 'res/images/cafe_bazzar.png';
import ICGooglePlay from 'res/images/google_play.png';

export default function Download() {

    return (<div className="hInLPT_vInFMS marginSmall paddingSmall">
        <div className="wInLP35_wInTFMS100 hideInLPT_showInFMS center">
            <img className="twoFromThree" src={ICDownloadDesktop} alt=""/>
        </div>
        <div className="wInLP65_wInTFMS100">
            <div className="marginSmall">
                <div className="largeTextBold">
                    {messages.applicationDownload}
                </div>
                <Space height={"1em"}/>
                <Divider/>
                <Space height={"1em"}/>
                <div className="largeText">
                    {messages.forApplicationDownload}
                </div>
                <Space height={"1.5em"}/>
            </div>
            <div className="toLeft marginSmall downloadButton">
                <img className="full clickable" src={ICCafeBazzar} alt=""
                     onClick={() => {
                         window.open(messages.cafeBazaarLink)
                     }}/>
            </div>
            <div className="toLeft marginSmall downloadButton">
                <img className="full clickable" src={ICGooglePlay} alt=""
                     onClick={() => {
                         window.open(messages.googlePlayLink)
                     }}/>
            </div>
        </div>
        <div className="wInLP35_wInTFMS100 showInLPT_hideInFMS">
            <img className="full" src={ICDownloadDesktop} alt=""/>
        </div>
    </div>)

}